import FederalDebt from './FederalDebt';

export default FederalDebt;
